import Components from "../components";

class ChannelFilters extends Components.Base {
  bind() {
    this.on('change', '.filter-group select', e => this.toggleSelect(e));
  }

  toggleSelect(event) {
    const $target = $(event.currentTarget);
    if ($target.val() === '') {
      $target.closest('.filter-group').remove();
    }
    if (this.$el.find('.filter-group option:selected[value=""]').length === 1) {
      // The template counts as 1
      this.$el
        .find('#filter-list')
        .append(this.$el.find('#filter-template').html());
    }
  }
}

Components.collection.register({
  selector: '.c-channel-filters',
  klass: ChannelFilters,
});
